module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column"
  }, [_c('div', {
    staticClass: "sub-page column"
  }, [_c('section', {
    staticClass: "take-place column activity-container container-background"
  }, [_c('div', {
    staticClass: "header-table row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\tConseillers\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "attached-item row"
  }, [_c('div', {
    staticClass: "phantom-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        _vm.showAddConseiller = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  }), _vm._v(" Ajouter un conseiller\n\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('Table', {
    attrs: {
      "elements": _vm.conseillers,
      "clickable": true
    },
    on: {
      "statuschange": _vm.updateStatus
    }
  }), _vm._v(" "), _c('baseModal', {
    attrs: {
      "show": _vm.showAddConseiller,
      "content": _vm.contentModal
    },
    on: {
      "close": function($event) {
        _vm.showAddConseiller = false
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4add7d8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Conseillers/index.vue
// module id = 629
// module chunks = 1